import { render, staticRenderFns } from "./purchaseOrder.vue?vue&type=template&id=6b1a5b4a&scoped=true"
import script from "./purchaseOrder.vue?vue&type=script&lang=js"
export * from "./purchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrder.vue?vue&type=style&index=0&id=6b1a5b4a&prod&lang=scss"
import style1 from "./purchaseOrder.vue?vue&type=style&index=1&id=6b1a5b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a5b4a",
  null
  
)

export default component.exports